export const handleButtonShadingFrontel = (
  row: any,
  setVerifiedClicked: (value: boolean) => void,
  setUnverifiedClicked: (value: boolean) => void
) => {
  if (row.ground_truth === "Verified") {
    setVerifiedClicked(true);
    setUnverifiedClicked(false);
  } else if (row.ground_truth === "Unverified") {
    setVerifiedClicked(false);
    setUnverifiedClicked(true);
  } else {
    setVerifiedClicked(false);
    setUnverifiedClicked(false);
  }
};
